module.exports = __webpack_public_path__ + "static/media/under16-birth-kit-icon.c9f96bb0.png";